{
  "(optional)": "(nepovinné)",
  "(required)": "(povinné)"
}
